<script>
import InfoLabel from '@/components/general/info-label.vue'
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'BookingDetailsClientInfoCard',
  components: {
    InfoLabel,
  },
  mixins: [baseMixin],
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getClientGroupName(booking) {
      return booking.clientGroup?.name ?? ''
    },
    groupAndLocationString(groupName, locationName) {
      return `${groupName ? `${groupName} - ` : groupName}${locationName}`
    },
  },
}
</script>

<template>
  <v-card class="rounded-lg" elevation="0">
    <v-card-text>
      <InfoLabel class="info-label__client-name mb-4">
        <template v-slot:label>
          <p class="mb-0 font-weight-medium">{{ booking.client.name }}</p>
        </template>
        <p class="mb-0 font-weight-medium opacity-5">
          {{
            groupAndLocationString(
              getClientGroupName(booking),
              booking.location.name
            )
          }}</p
        >
      </InfoLabel>
    </v-card-text>
  </v-card>
</template>
